import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
import columns from '../../../columns/transactions.jsx';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import { useSelector } from 'react-redux';
import { GetTransactionsApi } from '../../../api/request/transactions.js';
import Eye from '../../../assets/Eye.jsx';
import moment from 'moment/moment.js';
import ReactPlayer from 'react-player'
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
import ExportHandler from '../../../components/global/export/ExportHandler.jsx';

const { RangePicker } = DatePicker;

export default function TransferReport() {
    const { userDetails } = useSelector(state => state.user);
    const [selectedTransaction, setSelectedTransaction] = useState({});
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenModalvideo, setIsOpenModalvideo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [tutorials, setTutorials] = useState();
    const [tutorialsdetails, setTutorialsdetails] = useState({});
    const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
    const [dates, setDates] = useState([]);

    const getTransactions = async () => {
        try {
            setIsLoading(true);
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                FromDate: dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                FilterText: "AccountToWallet"
            }
            const { data } = await GetTransactionsApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return ({
                            ...item,
                            status: item?.status === "Success" ? (<span className='px-3 py-1 rounded-full uppercase text-xs text-center success_tag'>Success</span>) : (<span className='uppercase px-3 py-1 rounded-full text-xs text-center fail_tag'>Fail</span>),
                            actions: (<div className='cursor-pointer' onClick={() => { setSelectedTransaction(item); setIsOpenModal(true) }}><Eye /></div>),
                            transactionDate: item?.transactionDate ? moment(item?.transactionDate).format('DD-MM-YYYY LT') : null,
                            amount: `$ ${item?.amount}`
                        })
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setData([]);
            setIsLoading(false);
        }
    }

    const getAllTutorials = async () => {
        try {
            setIsLoading(true);
            let params = {
                tutorialType: "Transactions"
            }
            const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setTutorials(data?.data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getTransactions();
    }, [page, pageSize, dates]);

    useEffect(() => {
       
        getAllTutorials()
    }, []);

   


    const exportHandler = async () => {
        try {

            let params = {
                ApplyPagination: false,
                FromDate: dates && dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates && dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                FilterText: "AccountToWallet"
            }
            const { data } = await GetTransactionsApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) {
                return { data: data?.data, removableColumns: ['userId', 'transactionId'], fileName: 'Transactions' };
            } else {
                return { data: [], removableColumns: [] };
            }
        } catch (error) {
            return { data: [], removableColumns: [] };
        }
    };

    const addTutorialsModalHandler = (Item) => {
        setIsOpenModaldetails(true);
        setTutorialsdetails(Item)
    }


    return (
        <div className='transaction-container'>

            <div className='w-full'>
                <div className='flex flex-wrap justify-end items-center gap-5'>
                    <div className='flex flex-wrap'>
                        <div className='mr-4'>
                            <div>
                                <RangePicker className='border-light border-2 w-full mt-1 py-2'
                                    format='DD-MM-YYYY'
                                    onChange={(selectedDates) => {
                                        setDates(selectedDates ? selectedDates : []);
                                    }}
                                />
                            </div>
                        </div>
                        <div className='mt-2 mr-3' >
                            <ExportHandler exportHandler={exportHandler} />
                        </div>
                    </div>
                </div>
                <div className='my-6'>
                    <div className="border border-gray-200 rounded-xl">
                      <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    </div>
                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>

            <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Transaction Details' width={1000}>
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                        <div>
                            <p className='text-base font-normal '>Operation</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.operation}
                            </p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Payment From</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.paymentFrom}
                            </p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Payment To</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.paymentTo}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Amount</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {selectedTransaction?.amount?.toFixed(2)}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal pb-2'>Currency</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.currency}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Status</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.status}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Transaction Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{moment(selectedTransaction?.transactionDate).format('DD-MM-YYYY')}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Transaction Code</p>
                            <p className='text-xl primary font-semibold mt-2'>
                                {selectedTransaction?.transactionCode}</p>
                        </div>
                    </div>
                </div>

            </ModalComponent>

            <ModalComponent isOpen={isOpenModalvideo} setIsOpen={setIsOpenModalvideo} title='Tutorial' width={1000}>
                {tutorials && tutorials.length > 0 ? (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
                        {tutorials.map((item, index) => (
                            <div
                                key={index}
                                className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
                                onClick={() => addTutorialsModalHandler(item)}
                            >
                                <div className="relative pb-[56.25%] h-0">
                                    {item.youtubeUrl ? (
                                        <ReactPlayer
                                            url={item.youtubeUrl}
                                            className="absolute top-0 left-0 w-full h-full"
                                            width="100%"
                                            height="100%"
                                            controls
                                        />
                                    ) : item.videoUrl ? (
                                        <ReactPlayer
                                            url={item.videoUrl}
                                            className="absolute top-0 left-0 w-full h-full"
                                            width="100%"
                                            height="100%"
                                            controls
                                        />
                                    ) : (
                                        <p>Video not available</p>
                                    )}
                                </div>
                                <div className="text-center p-4">
                                    <p className="text-lg font-semibold line-limit-1">{item.title}</p>
                                    <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className='text-center'>
                        <p className='text-lg font-semibold'>Video not available</p>
                    </div>
                )}

            </ModalComponent>

            <ModalComponent isOpen={isOpenModaldetails} setIsOpen={setIsOpenModaldetails} title='Tutorial' width={800}>
                <div className="relative pb-[56.25%] h-0">

                    {tutorialsdetails.youtubeUrl ? (
                        <ReactPlayer
                            url={tutorialsdetails.youtubeUrl}
                            className="absolute top-0 left-0 w-full h-full"
                            width="100%"
                            height="100%"
                            controls
                        />
                    ) : tutorialsdetails.videoUrl ? (
                        <ReactPlayer
                            url={tutorialsdetails.videoUrl}
                            className="absolute top-0 left-0 w-full h-full"
                            width="100%"
                            height="100%"
                            controls
                        />
                    ) : (
                        <p>Video not available</p>
                    )}

                </div>
                <div className="text-center p-4">
                    <p className="text-lg font-semibold line-limit-1">{tutorialsdetails?.title}</p>
                    <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorialsdetails?.description}</p>
                </div>
            </ModalComponent>

        </div>
    )
}


